import type { Track } from "@similarweb/tracking-provider";

import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import type { LeadPriorityScore } from "app/pages/sales-intelligence/modules/lists/types/columns";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

export const createScoreCriteriaTrackingService = (track: Track) => {
    return {
        trackScoreCriteriaClick(place: string) {
            track("Scoring criteria", "click", createTrackingEventName("scoring criteria CTA", place));
        },
        trackDragAndDrop(priorityScore: LeadPriorityScore, signalType?: SignalType, signalName?: string) {
            track(
                "Scoring criteria",
                "drag and drop",
                createTrackingEventName("Add new scoring rule", priorityScore, signalType, signalName),
            );
        },
        trackClickAddSignal() {
            track(
                "Scoring criteria",
                "click add signal",
                createTrackingEventName("add new signal", "signals management popup from Scoring Criteria"),
            );
        },
        trackClickManageSignals() {
            track(
                "Scoring criteria",
                "click manage signals",
                createTrackingEventName("manage signals", "signals management popup from Scoring Criteria"),
            );
        },
        trackChangeContext(priorityScore: LeadPriorityScore) {
            track("Scoring criteria", "change context", createTrackingEventName(priorityScore));
        },
        trackViewSignalsClick() {
            track("Signals", "open signals in platform", "see all signals");
        },
    };
};
